import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

const getParamValueFromUrl = function (
    targetParamKey,
    paramsString = window.location.search.substring(1)
) {
    if (
        !targetParamKey ||
        !paramsString ||
        !paramsString.includes('=') ||
        typeof paramsString !== 'string' ||
        typeof targetParamKey !== 'string'
    )
        return '';
    const paramsArray = paramsString.split('&');
    if (paramsArray.length === 0) return '';
    const paramResults = paramsArray
        .map(val => val.split('='))
        .filter(key => key[0] === targetParamKey);
    return paramResults.length > 0 ? paramResults[0][1] : '';
};
const paramsToObject = function (paramsString = window.location.search.substring(1)) {
    const jsonObject = `{"${paramsString.replace(/&/g, '","').replace(/=/g, '":"')}"}`;

    return paramsString
        ? JSON.parse(jsonObject, (key, value) =>
              key === '' ? value : decodeURIComponent(value)
          )
        : {};
};
const createParams = source => {
    if (
        typeof source === 'string' ||
        (Object.constructor === Object && Object.entries(source).length === 0) ||
        (Array.isArray(source) && source.length === 0)
    )
        return '';
    const array = [];
    for (let key in source) {
        array.push(`${encodeURIComponent(key)}=${encodeURIComponent(source[key])}`);
    }
    return array.join('&');
};
const appendParamsToUrl = (redirectUrl, params) => {
    let url;
    try {
        url = new URL(redirectUrl);
    } catch (err) {
        LoggingHandler().logError(
            `Invalid redirectUrl passed to appendParamsToUrl: "${redirectUrl}"`,
            {
                searchTerm: 'url-params-error',
                fileName: 'URLParams.js',
                tags: ['navigation'],
                additionalData: {
                    error: err,
                },
            }
        );
        return redirectUrl; // fail gracefully : leave href unchanged
    }

    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });

    return url.toString();
};

export { getParamValueFromUrl, paramsToObject, createParams, appendParamsToUrl };
